import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter, Link } from 'react-router-dom';
import $ from 'jquery';
import TtsTest from './TtsTest';
import TtsDeploy from './TtsDeploy';

class TtsTestTab extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/cloud-tts/test-and-deploy";
      var path1 = window.origin + "/platform/cloud-tts/test-and-deploy/";
      if (currentPath === path || currentPath === path1) {
        $("#akshar-test-tab").addClass('active');
      } else if (currentPath.includes("/cloud-tts/test-and-deploy/deploy")) {
        $("#akshar-deploy-tab").addClass('active');
      }
      else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#akshar-test-tab,#akshar-deploy-tab")
        .on("click", function () {
          $("#akshar-test-tab,#akshar-deploy-tab")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);

          $(this).addClass('active')

        })
    })();
  }
  render() {
    return (
      <Router basename={window.contextPath}>
        <div id="tabPage">
          <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
            <div className="content-header" >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-5">
                    <h1 className="m-0 page-title">Test &amp; Deploy </h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid" style={{ marginLeft: '10px' }}>
              <div className="border-bottom"></div>
              {/* Nav tabs */}
              <div className="tab-class" >
                <ul className="nav nav-tabs border-bottom navCluster">
                  <Link to="/cloud-tts/test-and-deploy" className="nav-item" data-toggle="tab"
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="akshar-test-tab">Test</li>
                  </Link>
                  <Link to="/cloud-tts/test-and-deploy/deploy" className="nav-item" data-toggle="tab"
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="akshar-deploy-tab">Deploy</li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
          <Switch>
            <Route path="/cloud-tts/test-and-deploy/deploy" component={TtsDeploy}></Route>
            <Route path="/cloud-tts/test-and-deploy" component={TtsTest}></Route>
          </Switch>
        </div>
      </Router>

    );
  }
}
export default TtsTestTab;


// WEBPACK FOOTER //
// ./src/ttsUi/TtsTestTab.js